<template>
  <div>
    <loading :show="showProcessing" label="Processing"/>
    <overview-layout ref="overview" :tableCfg="tableCfg">
      <template slot="AdvancedFilter">
        <b-form ref="form" class="offset-md-1" autocomplete="off">
          <div class="row">
            <detail-field class="col-md-3" label="Student" field="student_id" :optionListApiUrl="'/students/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Status" field="contract_status_id" :optionListApiUrl="'/contract_status/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <!-- <detail-field class="col-md-3" label="Scholarship" field="scholarship_id" :optionListApiUrl="'/scholarships/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/> -->
            <detail-field class="col-md-3" label="Type" field="scholarship_type" :optionListApiUrl="'/scholarships_type/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="EU/Non-EU" field="scholarship_region" :optionListApiUrl="'/scholarships_region/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <!-- <detail-field class="col-md-3" label="Active" field="active" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>  -->
          </div>
          <div class="row">
            <detail-field class="col-md-3" label="Program" field="program_id" :optionListApiUrl="'/programs/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="University y1" field="y1_university_id" :optionListApiUrl="'/universities/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="University y2" field="y2_university_id" :optionListApiUrl="'/universities/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Date" type="date" field="date" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Open" field="open" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Round" field="application_round" :optionListApiUrl="'/contracts_round/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-3" label="Instalments" field="instalments" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          </div>
          <div class="row">
            <detail-field class="col-md-6" label="Bank info requested before" type="date" field="bankinfo_requested_before" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
            <detail-field class="col-md-6" label="Bank info updated before" type="date" field="bankinfo_updated_before" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          </div>
        </b-form>
      </template>
      <template slot="ExtraOptions" scope="props">
          <b-dropdown variant="default" size="sm">
            <template slot="button-content"> <i class="fa fa-cog"></i> </template>
            <b-dropdown-item @click="exportSelection('/contracts/download_report', 'Contracts.xlsx')">Export Selection</b-dropdown-item>
            <b-dropdown-item v-if="false" @click="exportSelection('/contracts/download_paymentstatus', 'Balance_to_date.xlsx')">Export Payment Status</b-dropdown-item>
            <b-dropdown-item @click="$refs.modalExportPaymentStatus.show()">Export Payment Status</b-dropdown-item>
            <b-dropdown-item @click="$refs.modalImportDreamApply.show()">Import DreamApply</b-dropdown-item>
            <b-dropdown-item v-if="false" @click="$refs.modalUpload.show()">Import Contracts</b-dropdown-item>
            <b-dropdown-item @click="$refs.modalUploadBankInfo.show()">Import Bank Info</b-dropdown-item>
          </b-dropdown>
          <b-dropdown v-if="hasSelections() && privAdministrator" variant="default" size="sm">
            <template slot="button-content">
                <i class="fa fa-rocket"></i> Batch
            </template>
            <b-dropdown-item @click="$refs.modalBulkEdit.show()">Bulk Edit</b-dropdown-item>
            <b-dropdown-item @click="$refs.modalSendBankInfoRequestOk.show()">Email bank info request scholarships</b-dropdown-item>
            <b-dropdown-item @click="$refs.modalSendPFStatusOk.show()">Send PF Status</b-dropdown-item>
          </b-dropdown>

      </template>
    </overview-layout>
    <b-modal ref="modalBulkEdit" size="lg" title="Bulk Edit" ok-title="Apply" close-title="Cancel" @ok="bulkOk('/contracts/bulk_edit')" >
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div class="row">
          <detail-field class="col-md-10" label="Status Date" field="contract_status_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field class="col-md-10" label="Y1 Finished" field="year1_finished" :rec="bulkRec" type="boolean" :hasNull="true" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field class="col-md-10" label="University Y2" field="y2_university_id" :optionListApiUrl="'/universities/choice/'" :rec="bulkRec" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field class="col-md-10" label="Y2 Finished" field="year2_finished" :rec="bulkRec" type="boolean" :hasNull="true" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field class="col-md-10" label="Start Date" field="start_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
        </div>
        <div class="row">
          <detail-field class="col-md-10" label="Contract Sent" field="contract_sent_date" :rec="bulkRec" type="date" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </b-modal>
    <b-modal ref="modalExportPaymentStatus" size="lg" title="Export Payment Status" ok-title="Export" close-title="Cancel" @ok="exportPaymentStatus" :ok-disabled="false">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
          <detail-field class="col-md-6" label="From" type="date" field="start" :rec="exportPaymentRec" vvalidate="ok" :validator="validator"/>
          <detail-field class="col-md-6" label="Until" type="date" field="end" :rec="exportPaymentRec" vvalidate="ok" :validator="validator"/>
      </b-form>
    </b-modal>
    <b-modal ref="modalImportDreamApply" size="lg" title="Import DreamApply" ok-title="Import" close-title="Cancel" @ok="importDreamApply" :ok-disabled="false">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
          <detail-field class="col-md-12" label="Academic Year" type="number" field="academic_year" :rec="importDreamApplyRec" vvalidate="ok" :validator="validator"/>
          <detail-field v-if="false" class="col-md-12" label="Enter value 1 to check for all updates (slow)" type="number" field="updates_in_last_days" :rec="importDreamApplyRec" vvalidate="ok" :validator="validator"/>
      </b-form>
    </b-modal>
    <b-modal ref="modalUpload" size="lg" title="Upload spreadsheet" ok-title="Upload" close-title="Cancel" @ok="uploadExcel" :ok-disabled="documentToUpload === null || documentToUpload === undefined">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <b-form-file  class="col-md-10" ref="fileinput" v-model="documentToUpload" placeholder=" " accept=".xlsx"></b-form-file>
      </b-form>
    </b-modal>
    <b-modal ref="modalUploadBankInfo" size="lg" title="Upload bank info XLSX or ZIP" ok-title="Upload" close-title="Cancel" @ok="uploadBankInfo" :ok-disabled="documentToUpload === null || documentToUpload === undefined">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <b-form-file  class="col-md-10" ref="fileinput" v-model="documentToUpload" placeholder=" " accept=".xlsx,.zip"></b-form-file>
      </b-form>
    </b-modal>
    <b-modal ref="modalSendBankInfoRequestOk" title="Send Bank Info Request" ok-title="Yes" close-title="No" @ok="$refs.overview.runBatch(sendBankInfoRequest, 'application_number')" >
      Are you sure you want to request the bank info for the selected items?
    </b-modal>
    <b-modal ref="modalSendPFStatusOk" title="Send Participation Fee Status" ok-title="Yes" close-title="No" @ok="$refs.overview.runBatch(sendPFStatus, 'application_number')" >
      Are you sure you want to send the participation fee status email for the selected items?
    </b-modal>
  </div>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import FieldDefs from './FieldDefs.js'
import loading from 'vue-full-loading'

export default {
  name: 'contract_overview',
  components: {
    loading
  },
  mixins: [OverviewMixin],
  data () {
    return {
      tableCfg: FieldDefs,
      showProcessing: false,
      documentToUpload: null,
      exportPaymentRec: {},
      importDreamApplyRec: {academic_year: 2021, updates_in_last_days: 0}
    }
  },
  methods: {
    exportPaymentStatus () {
      if (this.exportPaymentRec) {
        Object.assign(this.exportPaymentRec, this.searchRec)
        console.log(this.exportPaymentRec)
        this.api.downloadPost('/contracts/download_paymentstatus', this.exportPaymentRec, 'Balance_to_date.xlsx')
      }
    },
    importDreamApply () {
      if (this.importDreamApplyRec) {
        this.showProcessing = true
        this.api.post('/contracts/import_dream_apply', this.importDreamApplyRec, data => { this.showProcessing = false },
          error => { console.log('Error: ', error); this.showProcessing = false }, this.$refs.overview.alert)
      }
    },
    uploadExcel () {
      if (this.documentToUpload) {
        this.showProcessing = true
        this.api.uploadPost('/contracts/import', [this.documentToUpload], (response, state) => {
          this.showProcessing = false
          this.api.downloadPost('/contracts/get_import_results', {filename: response.data.filename, type: 'contracts'}, 'result.xlsx')
        }, 'uploading document', this.$refs.alert)
      }
    },
    uploadBankInfo () {
      if (this.documentToUpload) {
        // console.log('uploadBankInfo ', this.documentToUpload)
        this.showProcessing = true
        this.api.uploadPost('/contracts/import_bankinfo', [this.documentToUpload], (response, state) => {
          this.showProcessing = false
          this.api.downloadPost('/contracts/get_import_results', {filename: response.data.filename, type: 'bankinfo'}, 'result.xlsx')
        }, 'uploading document', this.$refs.alert)
      }
    },
    sendBankInfoRequest (id, okFnc, errorFnc) {
      this.api.post('/contracts/' + id + '/send_bankinfo_request', {}, okFnc, errorFnc, this.$refs.overview.alert)
    },
    sendPFStatus (id, okFnc, errorFnc) {
      this.api.post('/contracts/' + id + '/send_pf_status', {}, okFnc, errorFnc, this.$refs.overview.alert)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?5c2b7512